// extracted by mini-css-extract-plugin
export default {"container":"NumericalGraph_container__905Jn","vl":"NumericalGraph_vl__Flfvo","hl":"NumericalGraph_hl__ytUfC"};